const cloneDefaultQueryValue = value => (Array.isArray(value) ? [...value] : value);

export const SEARCH_ROUTE_DEFAULTS = {
  "/ptab/caselist": {
    sort: "-filing_date"
  },
  "/exparte/search": {
    sort: "-filing_date"
  },
  "/international-challenges/search": {
    sort: "-filing_date"
  },
  "/litigation/caselist": {
    sort: "-filed_date"
  },
  "/upc/search": {
    sort: "-filing_date",
    action_application_type: [
      "Provisionalmeasures",
      "Counter claim for revocation",
      "Infringement",
      "Revocation",
      "Appeal",
    ]
  },
  "/patents/search": {
    publication_type: "G",
    publication_status: "Active",
    sort: "-portfolio_score"
  },
  "/standards/open/mpeg": {
    sort: "-upload_date"
  },
  "/standards/open/3gpp": {
    sort: "-uploaded_date"
  },
  "/standards/open/ieee": {
    sort: "-create_date"
  },
  "/standards/open/ietf": {
    sort: "-upload_date"
  }
};

export const getDefaultSearchRouteQuery = routePathname => {
  const defaultRouteQuery = SEARCH_ROUTE_DEFAULTS[routePathname];
  return defaultRouteQuery
    ? Object.fromEntries(Object.entries(defaultRouteQuery).map(([key, value]) => [key, cloneDefaultQueryValue(value)]))
    : undefined;
};

export const areRouteQueriesEqual = (leftRouteQuery = {}, rightRouteQuery = {}) => JSON.stringify(leftRouteQuery) === JSON.stringify(rightRouteQuery);

export const getNormalizedRouteQuery = (routeQuery, sanitizeRouteQuery, defaultRouteQuery) => {
  const sanitizedRouteQuery = sanitizeRouteQuery(routeQuery);
  return Object.keys(sanitizedRouteQuery).length || !defaultRouteQuery ? sanitizedRouteQuery : { ...defaultRouteQuery };
};

export const getTableQueryWithInitialSort = (tableQuery, defaultSort, previousTableQuery) => {
  const nextTableQuery = { ...tableQuery };
  if (!defaultSort || "sort" in nextTableQuery || (previousTableQuery && "sort" in previousTableQuery)) return nextTableQuery;
  return { ...nextTableQuery, sort: defaultSort };
};